import Vue from 'vue/dist/vue.esm.js';
import * as bootstrap from 'bootstrap';

Vue.component('review-modal', {
    template: '#review-modal',
    delimiters: ['[[', ']]'],
/*    props: {
        product: {
            required: true,
            type: Object,
        },
    },*/

    mounted() {
        const urlSearchParams = new URLSearchParams(window.location.search);
        if(urlSearchParams.has('review')){
            const myModal = new bootstrap.Modal(document.getElementById('add-review'));
            myModal.show();
        }
    },
});